import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import saccoService from "@saccoService";

/**
 * Hook to create a sacco deposit linked to a debit transaction on a source account.
 * Handles currency conversion when deposit currency differs from the source account's native currency.
 * Calls the create_sacco_deposit_with_debit RPC which inserts both records atomically.
 * On success: invalidates ['transactions'] and ['sacco_deposits', membershipId].
 */
export default function useCreateSaccoDepositWithDebit() {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    mutationFn: async (input: SaccoDepositWithDebitRequest) => {
      if (!user) {
        throw new Error('User not authenticated');
      }

      return await saccoService.createDepositWithDebit(user.id, input)
    },
    onSuccess: (_data, input) => {
      queryClient.invalidateQueries({ queryKey: ['transactions'] });
      queryClient.invalidateQueries({ queryKey: ['sacco_deposits', input.membershipId] });
    },
    onError: (error: Error) => {
      console.error('Sacco deposit creation failed:', error);
    },
  });
}
